import React from "react";
import { useTranslation } from "react-i18next";

import SatisfactionRatioScatterplot from "./SatisfactionRatioScatterplot";
import {
  sortKeywordsByNotMeetingExpectations,
  sortKeywordsByRoomForGrowth,
} from "./utils";
import { KeywordReviewCrossAnalysisLocationData } from "../../types/keywordReviewCrossAnalysisData";

interface ILocationDataProps {
  locationData: KeywordReviewCrossAnalysisLocationData;
}

const LocationData: React.FunctionComponent<ILocationDataProps> = (props) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`EXPERIMENTAL_organizationFeaturesPage.${key}`);

  const { locationData } = props;

  const keywordsSortedByNotMeetingExpectations =
    sortKeywordsByNotMeetingExpectations(locationData);
  const keywordsSortedByRoomForGrowth =
    sortKeywordsByRoomForGrowth(locationData);

  return (
    <>
      <div className="white-border-panel">
        <h3>{t("satisfaction_ratio")}</h3>
        <SatisfactionRatioScatterplot locationData={locationData} />
      </div>
      <div className="keyword-review-cross-analysis-breakdowns">
        <div className="white-border-panel">
          <h3>{t("not_meeting_expectations.title")}</h3>
          <div className="text">{t("not_meeting_expectations.text")}</div>
          <table className="breakdown-list">
            <thead>
              <tr>
                <th>{t("breakdown_list.keyword")}</th>
                <th>{t("breakdown_list.keyword_value")}</th>
                <th>{t("breakdown_list.reviews_count")}</th>
                <th>{t("breakdown_list.ratio")}</th>
              </tr>
            </thead>
            <tbody>
              {keywordsSortedByNotMeetingExpectations
                .slice(0, 3)
                .map((keyword) => (
                  <tr key={keyword.keyword}>
                    <td title={keyword.keyword}>{keyword.keyword}</td>
                    <td>{keyword.keyword_value}</td>
                    <td>{keyword.reviews_count}</td>
                    <td>
                      {keyword.ratio === Infinity
                        ? "∞"
                        : `${(keyword.ratio * 100).toFixed(2)}%`}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        <div className="white-border-panel">
          <h3>{t("room_for_growth.title")}</h3>
          <div className="text">{t("room_for_growth.text")}</div>
          <table className="breakdown-list">
            <thead>
              <tr>
                <th>{t("breakdown_list.keyword")}</th>
                <th>{t("breakdown_list.keyword_value")}</th>
                <th>{t("breakdown_list.reviews_count")}</th>
                <th>{t("breakdown_list.ratio")}</th>
              </tr>
            </thead>
            <tbody>
              {keywordsSortedByRoomForGrowth.slice(0, 3).map((keyword) => (
                <tr key={keyword.keyword}>
                  <td title={keyword.keyword}>{keyword.keyword}</td>
                  <td>{keyword.keyword_value}</td>
                  <td>{keyword.reviews_count}</td>
                  <td>{(keyword.ratio * 100).toFixed(2)}%</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="white-border-panel">
        <h3>{t("summary")}</h3>
        <div className="text">{locationData.summary}</div>
      </div>
    </>
  );
};

export default LocationData;
